import type {SeoAttributes} from './types'

export * from './types'

export const DEFAULT_SEO_ATTRIBUTES: SeoAttributes = {}

/**
 * The attribute map is preloaded into `state.meta.seoAttributes` for the active
 * locale, and defaults to an empty map when the locale has no SEO attributes.
 * An empty map means "no SEO filters resolvable", so callers skip filter work.
 */
export const hasSeoAttributes = (seoAttributes: SeoAttributes): boolean =>
  !!seoAttributes && Object.keys(seoAttributes).length > 0
